<template>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header p-0 mb-50 mx-auto">
                    <a class="go-back" @click="goBack" >{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                </div>
                <div class="card-content">
                    <div class="row match-height">
                        <div class="col-xl-12 col-lg-12">
                            <div class="row">
                                <div class="col-12">
                                    <h4>APPEND CLIENT DOCUMENTS</h4>
                                    <div class="display-box mb-1">
                                        <div class="ml-2">
                                            <input
                                                class="custom-control-input"
                                                type="checkbox"
                                                name="append_affidavit"
                                                value="1"
                                                tabindex="4"
                                                v-model="checkbox"
                                                id="append_affidavit"

                                            />
                                            <label class="custom-control-label" for="Make_the_recipient_the_sender" @click="changeCheckbox">
                                                ID Theft Affidavit
                                            </label>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div class="card">
                                <div class="card-body">
                                    <div>
                                        <editor
                                            id="ChexSystems"
                                            v-model="letters.ChexSystems"
                                            :api-key="settingStore.tinymce.api_key"
                                            :init="settingStore.tinymce.configuration"
                                        />
                                    </div>
                                    <div class="d-flex justify-content-center my-1">
                                        <button class="btn btn-sm-block btn-primary" @click.once="submit" type="button" name="editorType" value="1">
                                            {{ localizationStore.translate("letter.left.submit.button.text") }}
                                        </button>
                                        <button
                                            id="letter-rewrite"
                                            class="btn btn-outline-primary ml-1"
                                            @click="spin"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("spin.letter.button.text") }}
                                            <b-popover
                                                target="letter-rewrite"
                                                placement="top"
                                                triggers="hover"
                                                :html="true"
                                            >
                                                <template #title>
                                                    {{ localizationStore.translate("chat.pricing.title") }}
                                                </template>
                                                <div class="row">
                                                    <div class="col-12">
                                                        <p v-if="planStore.openAI.serviceCharges.type == planStore.openAI.serviceCharges.fixed">
                                                            {{ localizationStore.translate("chat.pricing.message", { credit: planStore.getPrice('letter_rewrite') }) }}
                                                        </p>
                                                        <p v-else>
                                                            {{ localizationStore.translate("chat.pricing.dynamic.message") }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </b-popover>
                                        </button>
                                        <button
                                            data-toggle="modal"
                                            data-target="#chat-modal"
                                            class="btn btn-outline-primary mx-1"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("chat.button.title") }}
                                        </button>
                                        <button
                                            data-toggle="modal"
                                            data-target="#top-up-modal"
                                            class="btn btn-outline-primary"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("spin.purchase.button.text") }}
                                        </button>
                                    </div>
                                    <div class="row">
                                        <spinner ref="spinner" :user-info='userInfo' :editor-ref='editorRef' />
                                    </div>
                                    <div ref="ChexSystems" hidden>
                                        <p>
                                            {{ date }}
                                        </p>
                                        <p>
                                            {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
                                            {{ userStore.user.address }}<br />
                                            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }} <br />
                                            {{ userStore.user.ssn }} <br />
                                        </p>
                                        <p>
                                            {{ getCreditBureau('Chex Systems Inc.').address_name }} <br />
                                            {{ getCreditBureau('Chex Systems Inc.').street_address }} <br />
                                            {{ getCreditBureau('Chex Systems Inc.').city }}, {{ getCreditBureau('Chex Systems Inc.').state_abbrev }} {{ getCreditBureau('Chex Systems Inc.').zipcode }}
                                        </p>
                                        <div class="page">
                                            <p class="letter-content">
                                                In a letter dated [date of the first letter], I requested that you correct the following information in my ChexSystems report:
                                    
                                            </p>
                                            <p class="letter-content">
                                                <b>EXAMPLE 1:</b> Account Closed by Bank<br/>
                                                Source of Information: Insert source from your report<br/>
                                                Reported For: Insert issue from your report
                                                <br/>
                                                <br/>
                                                <b>EXAMPLE 2:</b> Unpaid Check<br/>
                                                Payee: Insert Merchant Name<br/>
                                                Amount of Check: Insert Amount of Check
                                            </p>
                                            <p class="letter-content">
                                                To date, I have not received confirmation that you have done so. As thirty (30) days 
                                                have now passed, this letter is my formal demand that this item be removed from the 
                                                ChexSystems database. Please note that your failure to do so violates the Fair Credit 
                                                Reporting Act.
                                            </p>
                                            <p class="letter-content">
                                                Please immediately send confirmation of the deletion to the address above. If I do not 
                                                hear from you within ten (10) business days, I am prepared to take legal action to remedy 
                                                the situation.
                                                <br />
                                            </p>  
                                    
                                            <p class="letter-content">
                                                After this credit freeze has been filed, please send me written confirmation to the address listed above.
                                                <br />
                                                <br />
                                                Sincerely, <br />
                                            </p>
                                        </div>
                                        <div class="page-content">
                                            <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
                                            <p style="padding-top:3rem; text-align: center;">
                                                <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                                                <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
                                            </p>
                                            <p v-if='userStore.user.address_verify_image_url'>
                                                <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { useLetterStore } from '../../stores/LetterStore.js'
    import { usePlanStore } from '../../stores/PlanStore.js'
    import { useSettingStore } from '../../stores/SettingStore.js'
    import moment from 'moment';
    import Editor from '@tinymce/tinymce-vue'
    import { BPopover } from 'bootstrap-vue-3'
    export default {
        props: {
            creditBureaus: {
                type: [Array, Object]
            },
            userInfo: {
                type: [Array, Object]
            },
        },
        components: {
            'editor': Editor
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                localizationStore: useLocalizationStore(),
                letters: reactive({
                    ChexSystems: null
                }),
                editorRef: ref(null),
                routes:ref([]),
                userInfo:reactive({}),
                letterStore:useLetterStore(),
                planStore: usePlanStore(),
                settingStore: useSettingStore(),
                checkbox:ref(false),
            };
        },
        watch: {
            'userStore.user'(value) {
                if (value != null) {
                    this.email = value.email;
                    this.userInfo = value;
                }
            }
        },
        mounted() {
            const $this = this;
            const letterSpinUrl = this.$router.resolve({
                name: 'spin-letter',
            });
            $this.routes = {
                'letterSpinUrl':letterSpinUrl.href
            };
            // document.onreadystatechange = () => {
            if (document.readyState == "complete") {
                setTimeout(() => {
                    this.$nextTick().then(() => {
                            this.letters.ChexSystems = this.$refs.ChexSystems && this.$refs.ChexSystems.innerHTML;
                    });
                }, 3000);
                this.$nextTick(() => {
                    if(!_.isEmpty(this.userStore.user)){
                        $this.userInfo = this.userStore.user;
                        $this.email = this.userStore.user.email;
                    }else{
                        $this.userStore.fetchUser();
                    }
                })
            }
            // }
        },
        methods: {
            goBack: function () {
                if (this.$route.params.client) {
                    const route = this.$router.resolve({
                        name: 'report',
                        params: { client: this.$route.params.client }
                    });
                    window.location.href = route.href;
                    return;
                }
                const route = this.$router.resolve({
                    name: 'disputes-report'
                });
                window.location.href = route.href;
            },
            getCreditBureau(name) {
                return _.find(this.creditBureaus, function(creditBureau) { return creditBureau.name == name; });
            },
            submit() {
                let params = { letter: this.$route.params.letter };
                if (this.$route.params.client) {
                    params.client = this.$route.params.client
                }
                if (this.$route.params.team) {
                    params.team = this.$route.params.team
                }
                const route = this.$router.resolve({
                    name: 'create-letter',
                    params: params
                }),
                $this = this,
                payload = {
                    multipe_letters: true,
                    letters: []
                };
                payload.letters.push({
                    letter_id: this.letterStore.getId($this.$route.params.letter),
                    credit_bureau_name: $this.getCreditBureau('Chex Systems Inc.').name,
                    letter_preview: tinymce.get('ChexSystems').getContent(),
                    append_affidavit : $this.checkbox,
                });
                axios.post(route.href, payload)
                .then(function (response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    toastr.success(response.data.message, 'Success!');
                    setTimeout(() => {
                        if($this.userStore.user.isDIY){
                            $this.$router.push({ name: 'disputes-report' });
                            return;
                        }
                        window.location.href = response.data.data.url;
                    }, 3000)
                })
                .catch(function (error) {
                });
            },
            spin() {
                this.$refs.spinner.spin(tinymce.get('ChexSystems'))
            },
            changeCheckbox(){
                this.checkbox = !this.checkbox
            }
        }
    };
</script>



